import React, { useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Pane, Heading, Paragraph } from 'evergreen-ui';
import FormBuilder from 'components/shared/FormBuilder';
import { onCompleted } from 'lib/formHelpers';
import { Form } from './form';
import { PROVISION_USER } from './queries';

const ProvisionUser = ({ onComplete }: any) => {
  const [errors, setErrors] = useState({});
  const [provisionUser, { loading }] = useMutation(PROVISION_USER, {
    onCompleted: (response: any) =>
      onCompleted({ response, setErrors, onComplete })
  });

  return (
    <Pane display="flex" flexDirection="column" flex="1">
      <Pane padding={16} background="tint2" borderBottom display="flex">
        <Heading size={500}>Provision new user</Heading>
      </Pane>
      <Pane padding={16}>
        <Paragraph marginBottom={24}>
          Note: this will generate a new user, and set the password to a random
          string. Please let the user know they will need to reset the password
          to continue.
        </Paragraph>

        <FormBuilder
          isSubForm
          initialValues={{ name: '', email: '' }}
          form={Form}
          errors={errors}
          isLoading={loading}
          onSubmit={(input: any) => {
            setErrors({});
            provisionUser({ variables: { input } });
          }}
        />
      </Pane>
    </Pane>
  );
};

export default ProvisionUser;
